import React , {useRef, useEffect, useState} from "react";
import { createPortal } from "react-dom";
import "./ElementAnimnPopUp.scss";
import { Divider, TextField, InputAdornment, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../styles/components/RightPanel.scss";
import "../../styles/components/PopupWindow.scss";
import CloseIcon from "../../images/iconclose.svg";
import DeleteKeyFrame from "../../images/DeleteKeyFrame.svg";
import DeleteKeyFrameDisable from "../../images/DeleteKeyFrameDisable.svg";
import Paste from "../../images/Paste.svg";
import pasteBlue from "../../images/BluePaste.svg";
import CopyKeyFrame from "../../images/CopyKeyFrame.svg";
import KeyframeTickMark from "../../images/keyframeTickmark.svg";
import CopyKeyFrameDisable from "../../images/CopyKeyFrameDisable.svg";
import left from "../../images/leftPos.svg";
import top from "../../images/topPos.svg";
import rotation from "../../images/rotation.svg";
import Slider from "@mui/material/Slider";
import { toast } from "react-toastify";
import {
  OutsideClickHandler,
  getValidInput,
  sanitizeDecimalFieldValue,
  TIMELINE_DECIMAL_FIELDS,
  normalizeTimelinePopUpOptions,
  roundTo2Decimals,
  formatDecimalDisplayValue,
  shouldPreserveDecimalInput,
} from "../../Uitls/Util";

function CustomanimationPopup({
  layerCompData,
  setLayerCompData,
  handleTimelinePopup,
  selectedComponent,
  setSelectedComponent,
  setPopUpOptions,
  popUpOptions,
  animationObject,
  setAnimationObject,
  copiedKeyFrame,
  setCopiedKeyFrame,
  setEdited,
  setundoFlag,
  setPopUpValuesEdited,
  openTimelinePopup,
  setOpenTimelinePopup,
  handleChangeTimelineProps,
  addKeyFrames,
  setShowTooltip,
  setClickedClose,
  keyFrameClicked,
  updateKeyFrames,
  popUpWindowPosn,
  setPopWindowPosn,
  setCopyPropertySelected,
  copyPropertySelected,
  selectedProperties,
  isNewAnimationOpen,
  setIsNewAnimationOpen,
  selectedPropertiesIndex,
}) {
  const animationPopUpRef = useRef(null);
  const buttonRef = useRef(null);
  const { t } = useTranslation();
  const easingOptions = ["none", "power1.in", "power1.out", "power1.inOut"];
  const [hoverRotateIcon, setHoverRotateIcon] = useState(false);
  const [hoverScaleIcon, setHoverScaleIcon] = useState(false);
  const [hoverOpacityIcon, setHoverOpacityIcon] = useState(false);
  const [dimensionsWhenOPened, setDimensionsWhenOPened] = useState({});
  const [scaleDisplay, setScaleDisplay] = useState(null);
  const dimensionWhenOPenedRef = React.useRef(dimensionsWhenOPened);

  const propertiesToUpdate = ["width", "height", "left", "top", "rotation"];

  propertiesToUpdate.forEach((property) => {
    if (
      popUpOptions[property] === undefined ||
      popUpOptions[property] === null
    ) {
      popUpOptions[property] = 0;
    }
  });
  useEffect(() => {
    setScaleDisplay(null);
  }, [keyFrameClicked, selectedComponent?.id]);

  // Position in viewport coords (popup is portaled + position:fixed).
  const placePopupAtAnchor = (anchorLeft, anchorTop, gap = 16) => {
    const popupEl = document.getElementById("popUpWindowNew");
    if (!popupEl) {
      return { left: anchorLeft, top: anchorTop };
    }
    const { width, height } = popupEl.getBoundingClientRect();
    return {
      left: anchorLeft - width * 0.25,
      top: anchorTop - height - gap,
    };
  };

  useEffect(() => {
    setPopWindowPosn(
      placePopupAtAnchor(popUpWindowPosn.left, popUpWindowPosn.top, 16),
    );
  }, []);
  const onHoverRotateIcon = () => {
    setHoverRotateIcon(true);
  };
  const onHoverScaleIcon = () => {
    setHoverScaleIcon(true);
  };
  const onLeaveScaleIcon = () => {
    setHoverScaleIcon(false);
  };

  const onHoverOpcaityIcon = () => {
    setHoverOpacityIcon(true);
  };
  const onLeaveOpcaityIcon = () => {
    setHoverOpacityIcon(false);
  };

  const onLeaveRotateicon = () => {
    setHoverRotateIcon(false);
  };

  OutsideClickHandler(
    animationPopUpRef,
    (e) => {
      // Flash-icon clicks are handled by timeline toggle logic.
      if (
        e?.target?.id === "powerIconCircle" ||
        e?.target?.id === "powerIconCircle2"
      )
        return;
      setClickedClose(true);
      handleTimelinePopup(e, dimensionWhenOPenedRef.current);
      setEdited(false);
      setOpenTimelinePopup({
        popupWindow: false,
        fromUnRedo: false,
      });
      setIsNewAnimationOpen(false);
    },
    openTimelinePopup,
    selectedComponent.id,
  );

  const chanageOpacityOnmouseUp = (e, newValue) => {
    let event1 = {
      target: {
        name: "opacity",
        value: newValue / 100,
      },
    };
    setPopUpValuesEdited(true);
  };
  const handleChangeOpacity = (event, newValue) => {
    let percentageValue = newValue * 100;
    setPopUpOptions((prevState) => ({
      ...prevState,
      opacity: percentageValue,
      clicked: true,
    }));
  };

  const changeScaleOnMouseUp = (event, newValue) => {
    let event1 = {
      target: {
        name: "transform",
        value: newValue / 10,
      },
    };
    setPopUpValuesEdited(true);
  };

  const handleChangeScale = (event, newValue) => {
    let percentageValue = newValue * 100;
    setPopUpOptions((prevState) => ({
      ...prevState,
      scale: percentageValue,
    }));
  };
  useEffect(() => {
    document.addEventListener("scroll", handleTimelinePopup, true);
    document
      .getElementById("marker")
      .addEventListener("mousedown", handleTimelinePopup, true);

    return () => {
      document.removeEventListener("scroll", handleTimelinePopup, true);
      document
        .getElementById("marker")
        .removeEventListener("mousedown", handleTimelinePopup, true);
    };
  }, []);

  useEffect(() => {
    setClickedClose(false);
    let tempSelectedComp = JSON.parse(JSON.stringify(selectedComponent));
    let tempPopUpOptions = {};
    let dimensions = {};
    if (
      keyFrameClicked === "plusCustomAnmn" ||
      keyFrameClicked === "Diamond+Icon"
    ) {
      tempPopUpOptions = {
        ...popUpOptions,
        left: selectedComponent?.componentStyles?.left,
        top: selectedComponent?.componentStyles?.top,
        width: selectedComponent?.componentStyles?.width,
        height: selectedComponent?.componentStyles?.height,
        ease: "NONE",
        opacity: 100,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 100,
        end: selectedComponent?.componentStyles?.end,
        translateX: selectedComponent?.componentStyles?.translateX || 0,
        translateY: selectedComponent?.componentStyles?.translateY || 0,
        transformOriginX:
          selectedComponent?.componentStyles?.transformOriginX || 0,
        transformOriginY:
          selectedComponent?.componentStyles?.transformOriginY || 0,
        transformOriginZ:
          selectedComponent?.componentStyles?.transformOriginZ || 0,
      };
    } else {
      tempPopUpOptions = {
        ...popUpOptions,
        left: animationObject[selectedComponent.id]?.animation[keyFrameClicked]
          ?.x,
        top: animationObject[selectedComponent.id]?.animation[keyFrameClicked]
          ?.y,
        width:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.width,
        height:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.height,
        ease: animationObject[selectedComponent.id]?.animation[keyFrameClicked]
          ?.ease,
        opacity:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.opacity * 100,
        rotation:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.rotation,
        rotationX:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.rotationX,
        rotationY:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.rotationY,
        scale:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.transform * 100,
        end: animationObject[selectedComponent.id]?.animation[keyFrameClicked]
          ?.end,
        translateX:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.translateX,
        translateY:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.translateY,
        transformOriginX:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.transformOriginX,
        transformOriginY:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.transformOriginY,
        transformOriginZ:
          animationObject[selectedComponent.id]?.animation[keyFrameClicked]
            ?.transformOriginZ,
      };
    }
    dimensions = {
      left:
        tempPopUpOptions?.left || tempSelectedComp?.componentStyles?.left || 0,
      top: tempPopUpOptions?.top || tempSelectedComp?.componentStyles?.top || 0,
      width:
        tempPopUpOptions?.width ||
        tempSelectedComp?.componentStyles?.width ||
        0,
      height:
        tempPopUpOptions?.height ||
        tempSelectedComp?.componentStyles?.height ||
        0,
      translateX:
        tempPopUpOptions?.translateX ||
        tempSelectedComp?.componentStyles?.translateX ||
        0,
      translateY:
        tempPopUpOptions?.translateY ||
        tempSelectedComp?.componentStyles?.translateY ||
        0,
    };
    dimensionWhenOPenedRef.current = dimensions;
    setDimensionsWhenOPened(dimensions);
    setPopUpOptions(normalizeTimelinePopUpOptions(tempPopUpOptions));
  }, []);
  useEffect(() => {
    if (keyFrameClicked === "Diamond+Icon") {
      setPopWindowPosn(
        placePopupAtAnchor(popUpWindowPosn.left, popUpWindowPosn.top, 15),
      );
    } else if (typeof keyFrameClicked !== "string") {
      setPopWindowPosn(
        placePopupAtAnchor(popUpWindowPosn.left, popUpWindowPosn.top, 15),
      );
    }
  }, []);

  const copyKeyFrames = () => {
    setCopyPropertySelected(true);
    setCopiedKeyFrame(
      animationObject[selectedProperties.id]?.animation[
        selectedPropertiesIndex.keyIndex
      ],
    );
    setClickedClose(true);
    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Copied Successfully")}
      </div>,
    );
    handleTimelinePopup(dimensionsWhenOPened);
  };
  const pasteKeyFrame = () => {
    if (!selectedProperties.hasOwnProperty("id")) {
      toast.error(
        <div className="notificationText">
          {t("Please select the component")}
        </div>,
      );
      return;
    }
    if (copiedKeyFrame === "") {
      toast.error(
        <div className="notificationText">{t("No Key frame is copied")}</div>,
      );
      return;
    }
    let tempCopiedKeyFrame = { ...copiedKeyFrame };

    if (!isNewAnimationOpen) {
      let tempLayer = [...layerCompData];
      tempLayer[selectedPropertiesIndex.index].componentStyles.left =
        tempCopiedKeyFrame.x;
      tempLayer[selectedPropertiesIndex.index].componentStyles.top =
        tempCopiedKeyFrame.y;
      tempLayer[selectedPropertiesIndex.index].componentStyles.height =
        tempCopiedKeyFrame.height;
      tempLayer[selectedPropertiesIndex.index].componentStyles.width =
        tempCopiedKeyFrame.width;
      setLayerCompData(tempLayer);
    }

    setSelectedComponent((prevState) => ({
      ...prevState,
      componentStyles: {
        ...prevState.componentStyles,
        left: tempCopiedKeyFrame.x,
        top: tempCopiedKeyFrame.y,
        width: tempCopiedKeyFrame.width,
        height: tempCopiedKeyFrame.height,
        translateX: tempCopiedKeyFrame.translateX || 0,
        translateY: tempCopiedKeyFrame.translateY || 0,
      },
    }));

    let popUpvalues = {
      ...popUpOptions,
      left: tempCopiedKeyFrame.x,
      top: tempCopiedKeyFrame.y,
      width: tempCopiedKeyFrame.width,
      height: tempCopiedKeyFrame.height,
      ease: tempCopiedKeyFrame.ease,
      skewAnimation: tempCopiedKeyFrame.skewAnimation,
      opacity: Math.round(tempCopiedKeyFrame.opacity * 100),
      rotation: tempCopiedKeyFrame.rotation,
      rotationX: tempCopiedKeyFrame.rotationX,
      rotationY: tempCopiedKeyFrame.rotationY,
      scale: Math.round(tempCopiedKeyFrame.transform * 100),
      translateX: tempCopiedKeyFrame.translateX || 0,
      translateY: tempCopiedKeyFrame.translateY || 0,
      transformOriginX: tempCopiedKeyFrame.transformOriginX || 0,
      transformOriginY: tempCopiedKeyFrame.transformOriginY || 0,
      transformOriginZ: tempCopiedKeyFrame.transformOriginZ || 0,
    };
    setPopUpOptions(popUpvalues);
    setCopyPropertySelected(false);
    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Pasted Successfully")}
      </div>,
    );
    setClickedClose(true);
  };
  const deleteKeyFrame = () => {
    if (
      !selectedProperties?.id ||
      selectedPropertiesIndex?.index === undefined ||
      selectedPropertiesIndex?.keyIndex === undefined
    ) {
      return;
    }

    const componentId = selectedProperties.id;
    const layerIndex = selectedPropertiesIndex.index;
    const keyIndex = selectedPropertiesIndex.keyIndex;
    const keyFrameToDelete =
      animationObject[componentId]?.animation?.[keyIndex];
    const isDeletedKeyFrameCopied =
      copiedKeyFrame !== "" && copiedKeyFrame === keyFrameToDelete;

    const updatedLayerCompData = layerCompData.map((layer, index) => {
      if (index !== layerIndex) return layer;
      return {
        ...layer,
        keyFrames: (layer.keyFrames || []).filter((_, i) => i !== keyIndex),
      };
    });
    const updatedAnimationObject = {
      ...animationObject,
      [componentId]: {
        ...animationObject[componentId],
        animation: (animationObject[componentId]?.animation || []).filter(
          (_, i) => i !== keyIndex,
        ),
      },
    };
    setLayerCompData(updatedLayerCompData);
    setAnimationObject(updatedAnimationObject);
    setSelectedComponent((prevState) => {
      if (prevState?.id !== componentId) return prevState;
      return {
        ...prevState,
        keyFrames: (prevState?.keyFrames || []).filter(
          (_, i) => i !== keyIndex,
        ),
      };
    });

    if (isDeletedKeyFrameCopied) {
      setCopiedKeyFrame("");
      setCopyPropertySelected(false);
    }

    handleTimelinePopup(true);
    setClickedClose(true);

    toast.success(
      <div className="notificationText d-flex">
        {t("Keyframe Deleted Successfully")}
      </div>,
    );
    handleTimelinePopup(dimensionsWhenOPened);
  };

  const getPrevKeyFrameValues = () => {
    let popUpvalues = {};

    let selComp = animationObject[selectedComponent.id]?.animation?.filter(
      (elem) => {
        if (
          keyFrameClicked === "plusCustomAnmn" ||
          keyFrameClicked === "Diamond+Icon"
        )
          return elem;

        let n = selectedComponent?.keyFrames[keyFrameClicked] / 45;
        let keyFrameRange =
          parseInt(n) + Math.ceil((n - Math.floor(n)) * 10) / 10;
        if (keyFrameRange <= elem.end + 0.1 && keyFrameRange >= elem.end - 0.1)
          return elem;
      },
    );
    if (selComp?.length > 0) {
      popUpvalues = {
        ...popUpOptions,
        left: selComp[0].x,
        top: selComp[0].y,
        width: selComp[0].width,
        height: selComp[0].height,
        ease: selComp[0].ease,
        skewAnimation: selComp[0].skewAnimation,
        opacity: Math.round(selComp[0].opacity * 100),
        rotation: selComp[0].rotation,
        scale: Math.round(selComp[0].transform * 100),
      };
    } else if (selectedComponent.componentStyles) {
      popUpvalues = {
        ...popUpOptions,
        left: selectedComponent.componentStyles.left,
        top: selectedComponent.componentStyles.top,
        width: selectedComponent.componentStyles.width,
        height: selectedComponent.componentStyles.height,
        ease: "NONE",
        skewAnimation: false,
        opacity: 100,
        rotation: 0,
        scale: 100,
      };
    }
    setPopUpOptions(popUpvalues);
  };

  const handlEasingOps = (e) => {
    setPopUpOptions({
      ...popUpOptions,
      ease: e.target.value,
    });
    let tempElemLayers = [...layerCompData];
    tempElemLayers.forEach((entry, index) => {
      if (entry.id === selectedComponent.id)
        tempElemLayers[index].componentStyles.ease = e.target.value;
    });
    setundoFlag(true);
    setLayerCompData(tempElemLayers);
  };
  const toggleSkewCheck = (e) => {
    if (selectedComponent) {
      let tempSlected = { ...selectedComponent };
      tempSlected.componentStyles.skewAnimation = e.target.checked;
      setSelectedComponent(tempSlected);
    }
  };
  const handleTextFieldChangeScale = (event, blur) => {
    let val = getValidInput(
      { target: { name: "scale", value: event.target.value } },
      "scale",
      blur,
    );
    if (val === -1) return;
    val = sanitizeDecimalFieldValue(
      val,
      blur,
      TIMELINE_DECIMAL_FIELDS,
      "scale",
    );
    if (val === -1) return;

    if (shouldPreserveDecimalInput(val, blur)) {
      setScaleDisplay(val);
      return;
    }

    setScaleDisplay(null);
    const parsed = parseFloat(val);
    const xValue = Number.isNaN(parsed)
      ? 1
      : roundTo2Decimals(Math.min(10, Math.max(0, parsed)));
    setPopUpOptions((prevState) => ({
      ...prevState,
      scale: roundTo2Decimals(xValue * 100),
    }));
    if (blur === "blur") {
      setPopUpValuesEdited(true);
    }
  };

  const getScaleDisplayValue = () => {
    if (scaleDisplay !== null) return scaleDisplay;
    return Number.isNaN(popUpOptions.scale)
      ? 1
      : formatDecimalDisplayValue(popUpOptions.scale / 100);
  };
  const handleTextFieldChangeOpacity = (event) => {
    let inputValue = parseFloat(event.target.value);
    inputValue = isNaN(inputValue) ? 0 : Math.min(1, Math.max(0, inputValue));
    inputValue = parseFloat(inputValue.toFixed(1));
    let percentageValue = inputValue * 100;
    setPopUpOptions((prevState) => ({
      ...prevState,
      opacity: percentageValue,
    }));
  };
  const handleKeyDown = (property) => (e) => {
    if (
      [property] == "width" ||
      [property] == "height" ||
      [property] == "top" ||
      [property] == "left" ||
      [property] == "translateX" ||
      [property] == "translateY" ||
      [property] == "transformOriginZ"
    ) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setPopUpOptions((prevState) => ({
          ...prevState,
          [property]:
            prevState[property] == 9999
              ? prevState[property]
              : ++prevState[property],
        }));
      } else if (e.key === "ArrowDown") {
        if (
          property == "top" ||
          property == "left" ||
          property == "translateX" ||
          property == "translateY" ||
          [property] == "transformOriginZ"
        ) {
          setPopUpOptions((prevState) => ({
            ...prevState,
            [property]:
              prevState[property] == -9999
                ? prevState[property]
                : prevState[property] - 1,
          }));
        } else {
          setPopUpOptions((prevState) => ({
            ...prevState,
            [property]:
              prevState[property] > 0
                ? prevState[property] - 1
                : prevState[property],
          }));
        }
      }
    } else if ([property] == "opacity") {
      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
        const increment =
          e.key === "ArrowUp" ? 0.1 : e.key === "ArrowDown" ? -0.1 : 0;

        if (increment === 0) return;

        setPopUpOptions((prevState) => {
          let currentValue = prevState[property] / 100;
          let newValue = parseFloat((currentValue + increment).toFixed(1));
          newValue = Math.max(0, Math.min(1, newValue));
          let percentageValue = newValue * 100;
          return {
            ...prevState,
            [property]: percentageValue,
          };
        });
      }
    } else if ([property] == "scale") {
      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        e.preventDefault();
        const increment = e.key === "ArrowUp" ? 1 : -1;
        if (increment === 0) return;
        setPopUpOptions((prevState) => {
          let currentValue = prevState[property] / 100;
          let newValue = currentValue + increment;
          newValue = Math.min(10, Math.max(0, newValue));
          let percentageValue = newValue * 100;
          return {
            ...prevState,
            [property]: percentageValue,
          };
        });
      }
    } else if (
      [property] == "rotation" ||
      [property] == "rotationX" ||
      [property] == "rotationY"
    ) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setPopUpOptions((prevState) => ({
          ...prevState,
          [property]:
            prevState[property] == 360
              ? prevState[property]
              : ++prevState[property],
        }));
      } else if (e.key === "ArrowDown") {
        setPopUpOptions((prevState) => ({
          ...prevState,
          [property]:
            prevState[property] > -360
              ? prevState[property] - 1
              : prevState[property],
        }));
      }
    } else if (
      property === "transformOriginX" ||
      property === "transformOriginY"
    ) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        setPopUpOptions((prevState) => ({
          ...prevState,
          [property]: (prevState[property] || 0) + 1,
        }));
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        setPopUpOptions((prevState) => ({
          ...prevState,
          [property]: (prevState[property] || 0) - 1,
        }));
      }
    }
  };
  const trimSelectedCompId = selectedComponent?.id?.slice(0, -1);
  return createPortal(
    <div
      ref={animationPopUpRef}
      className={"box-container1"}
      style={{
        left: popUpWindowPosn.left,
        top: popUpWindowPosn.top,
      }}
      id="popUpWindowNew"
    >
      <div className="box1">
        <div className="boxContent">
          <div className="lhsPart">
            <div className="elementAnimationText">
              {trimSelectedCompId} Animation
            </div>
          </div>

          <div className="rhsPart">
            <div className="copyDelete">
              <Tooltip title="Paste" placement="top" arrow>
                <img
                  src={copyPropertySelected ? pasteBlue : Paste}
                  onClick={
                    copyPropertySelected
                      ? () => {
                          pasteKeyFrame();
                        }
                      : undefined
                  }
                  alt="Paste"
                />
              </Tooltip>
              <Tooltip title="Copy" placement="top" arrow>
                {isNewAnimationOpen ? (
                  <img src={CopyKeyFrameDisable} alt="Copy" />
                ) : (
                  <img
                    onClick={() => {
                      copyKeyFrames();
                    }}
                    src={CopyKeyFrame}
                    alt="Copy"
                  />
                )}
              </Tooltip>
              <Tooltip title="Delete" placement="top" arrow>
                {isNewAnimationOpen ? (
                  <img src={DeleteKeyFrameDisable} alt="Delete" />
                ) : (
                  <img
                    onClick={() => {
                      deleteKeyFrame();
                    }}
                    src={DeleteKeyFrame}
                    alt="Delete"
                  />
                )}
              </Tooltip>
              <Tooltip title="Close" placement="top" arrow>
                <img
                  src={CloseIcon}
                  onClick={(e) => {
                    setClickedClose(true);
                    handleTimelinePopup(e, dimensionsWhenOPened);
                    setIsNewAnimationOpen(false);
                  }}
                  alt="Close"
                  className="img-fluid closeIconn"
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <Divider className="dividerClass" />
        <div className="inputFields">
          <div className="dimen">
            <div className="sizePos">
              <div className="xywh">
                <div clasName="sp">W</div>
                <TextField
                  disabled={selectedComponent?.componentStyles?.lockBoolean}
                  className="textFieldSP"
                  id="width"
                  value={popUpOptions.width}
                  name="width"
                  size="small"
                  onKeyDown={handleKeyDown("width")}
                  autoComplete="off"
                  inputProps={{
                    style: {
                      marginTop: "-18px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                    },
                  }}
                  onChange={(e) => handleChangeTimelineProps(e)}
                  onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                />
              </div>
              <div className="xywh" style={{ marginLeft: "4px" }}>
                <div clasName="sp">
                  <img src={left} />
                </div>
                <TextField
                  disabled={selectedComponent?.componentStyles?.lockBoolean}
                  className="textFieldSP textFieldLTR"
                  id="xCoord"
                  value={popUpOptions.left}
                  name="left"
                  size="small"
                  autoComplete="off"
                  onKeyDown={handleKeyDown("left")}
                  inputProps={{
                    style: {
                      marginTop: "-18px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                    },
                  }}
                  onChange={(e) => handleChangeTimelineProps(e)}
                  onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                />
              </div>
            </div>
            <div className="sizePos">
              <div className="xywh" style={{ marginLeft: "5px" }}>
                <div className="sp">H</div>
                <TextField
                  disabled={selectedComponent?.componentStyles?.lockBoolean}
                  className="textFieldSP"
                  id="height"
                  value={popUpOptions.height}
                  name="height"
                  size="small"
                  autoComplete="off"
                  onKeyDown={handleKeyDown("height")}
                  inputProps={{
                    style: {
                      marginTop: "-18px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                    },
                  }}
                  onChange={(e) => handleChangeTimelineProps(e)}
                  onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                />
              </div>
              <div className="xywh" style={{ marginLeft: "4px" }}>
                <div className="xywh">
                  <div className="sp">
                    <img src={top} />
                  </div>
                  <TextField
                    disabled={selectedComponent?.componentStyles?.lockBoolean}
                    className="textFieldSP textFieldLTR"
                    id="top"
                    value={popUpOptions.top}
                    name="top"
                    size="small"
                    autoComplete="off"
                    onKeyDown={handleKeyDown("top")}
                    inputProps={{
                      style: {
                        marginTop: "-18px",
                        marginBottom: "-15px",
                        fontSize: "11px",
                      },
                    }}
                    onChange={(e) => handleChangeTimelineProps(e)}
                    onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="animationEffects">
            <div className="easing">
              <div className="anmnEffProps">{t("timelineMenu.easing")}</div>
              <select
                name="ease"
                className="easingDropDn"
                onChange={(e) => handlEasingOps(e)}
                value={popUpOptions.ease}
              >
                {easingOptions.map((easingOption, id) => {
                  return (
                    <option key={id} value={easingOption}>
                      {easingOption === "power1.in"
                        ? "Ease in"
                        : easingOption === "power1.out"
                          ? "Ease out"
                          : easingOption === "power1.inOut"
                            ? "Ease in out"
                            : "None"}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="easing">
              <div className="anmnEffProps">{t("timelineMenu.opacity")}</div>
              <div className="opacityRHS">
                <TextField
                  disabled={selectedComponent?.componentStyles?.lockBoolean}
                  className="textFieldSP textFieldOS"
                  id="height"
                  value={popUpOptions.opacity / 100}
                  name="height"
                  size="small"
                  autoComplete="off"
                  onKeyDown={handleKeyDown("opacity")}
                  inputProps={{
                    style: {
                      marginTop: "-18px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                    },
                    type: "number",
                    step: "0.1",
                    min: "0",
                    max: "1",
                    pattern: "\\d*\\.?\\d{0,1}",
                  }}
                  onChange={handleTextFieldChangeOpacity}
                />
                <div className="slider">
                  <Slider
                    value={popUpOptions.opacity / 100}
                    onChange={handleChangeOpacity}
                    onChangeCommitted={chanageOpacityOnmouseUp}
                    aria-labelledby="continuous-slider"
                    min={0}
                    max={1}
                    step={0.1}
                  />
                </div>
              </div>
            </div>
            <div className="easing">
              <div className="anmnEffProps">{t("timelineMenu.scale")}</div>
              <div className="opacityRHS">
                <TextField
                  disabled={selectedComponent?.componentStyles?.lockBoolean}
                  className="textFieldSP textFieldOS"
                  id="scaleInput"
                  value={getScaleDisplayValue()}
                  name="scale"
                  size="small"
                  autoComplete="off"
                  onKeyDown={handleKeyDown("scale")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <span
                          style={{
                            position: "absolute",
                            color: "black",
                            fontSize: "11px",
                            // right: `${(() => {
                            //   const value = String(getScaleDisplayValue());
                            //   const length = value.length;
                            //   const position = 28;
                            //   return `${position}px`;
                            // })()}`,
                            right: "5px",
                            top: "-6px",
                          }}
                        >
                          X
                        </span>
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    style: {
                      marginTop: "-18px",
                      marginBottom: "-15px",
                      fontSize: "11px",
                    },
                  }}
                  onChange={(e) => handleTextFieldChangeScale(e)}
                  onBlur={(e) => handleTextFieldChangeScale(e, "blur")}
                />
                <div className="slider">
                  <Slider
                    value={
                      isNaN(popUpOptions.scale)
                        ? 100
                        : popUpOptions.scale / 100
                    }
                    onChange={handleChangeScale}
                    onChangeCommitted={changeScaleOnMouseUp}
                    aria-labelledby="continuous-slider"
                    defaultValue={1}
                    min={1}
                    max={10}
                    step={1}
                  />
                </div>
              </div>
            </div>
            <div className="easing" style={{ marginBottom: "20px" }}>
              <div className="anmnEffProps" style={{ paddingRight: "18px" }}>
                Translation
              </div>
              <div></div>
              <div className="tr translat">X</div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY xAndY"
                style={{ marginLeft: "20px" }}
                id="xCoord"
                value={popUpOptions.translateX}
                name="translateX"
                size="small"
                autoComplete="off"
                inputProps={{
                  style: {
                    marginTop: "-18px",
                    marginBottom: "-15px",
                    fontSize: "11px",
                  },
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("translateX")}
              />
              <div
                className="tr "
                style={{
                  marginRight: "20px",
                  marginLeft: "-40px",
                  position: "relative",
                  right: "30px",
                }}
              >
                Y
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY xAndY"
                style={{
                  marginRight: "0",
                  position: "relative",
                  right: "27px",
                }}
                id="xCoord"
                value={popUpOptions.translateY}
                name="translateY"
                size="small"
                autoComplete="off"
                inputProps={{
                  style: {
                    marginTop: "-18px",
                    marginBottom: "-15px",
                    fontSize: "11px",
                  },
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("translateY")}
              />
            </div>
            <div className="easing" style={{ marginBottom: "20px" }}>
              <div className="anmnEffProps">Rotation</div>
              <div className="tr" style={{ marginLeft: "55px" }}>
                <div className="sp">
                  <img src={rotation} />
                </div>
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginLeft: "30px" }}
                id="xCoord"
                value={popUpOptions.rotation}
                name="rotation"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    bottom: "4px",
                    height: "16.7px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          position: "absolute",
                          color: "black",
                          fontSize: "11px",
                          right: `${(() => {
                            const length =
                              popUpOptions.rotation.toString().length;
                            const position =
                              length === 4
                                ? 14.2
                                : length === 3
                                  ? 20
                                  : length === 2
                                    ? 26.5
                                    : 32.5;
                            return `${position}px`;
                          })()}`,
                          top: "-8px",
                        }}
                      >
                        &deg;
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("rotation")}
              />
              <div
                className="tr"
                style={{
                  marginRight: "30px",
                  marginLeft: "20px",
                }}
              >
                X
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginRight: "0" }}
                id="xCoord"
                value={popUpOptions.rotationX}
                name="rotationX"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    bottom: "4px",
                    height: "16.7px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          position: "absolute",
                          color: "black",
                          fontSize: "11px",
                          right: `${(() => {
                            const length = popUpOptions.rotationX
                              ? popUpOptions.rotationX.toString().length
                              : 0;
                            const position =
                              length === 4
                                ? 14.2
                                : length === 3
                                  ? 18.5
                                  : length === 2
                                    ? 26.5
                                    : 32.5;
                            return `${position}px`;
                          })()}`,
                          top: "-8px",
                        }}
                      >
                        &deg;
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("rotationX")}
              />
              <div
                className="tr"
                style={{ marginRight: "30px", marginLeft: "20px" }}
              >
                Y
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginRight: "0" }}
                id="xCoord"
                value={popUpOptions.rotationY}
                name="rotationY"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    bottom: "4px",
                    height: "16.7px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          position: "absolute",
                          color: "black",
                          fontSize: "11px",
                          right: `${(() => {
                            const length = popUpOptions.rotationY
                              ? popUpOptions?.rotationY.toString().length
                              : 0;
                            const position =
                              length === 4
                                ? 14.2
                                : length === 3
                                  ? 20
                                  : length === 2
                                    ? 26.5
                                    : 32.5;
                            return `${position}px`;
                          })()}`,
                          top: "-8px",
                        }}
                      >
                        &deg;
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("rotationY")}
              />
            </div>
            <div className="easing" style={{ marginBottom: "20px" }}>
              <div className="anmnEffProps">Transform Origin</div>
              <div className="tr">X</div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginLeft: "30px" }}
                id="xCoord"
                value={popUpOptions.transformOriginX}
                name="transformOriginX"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    marginTop: "-5px",
                    height: "20px",
                    fontSize: "11px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          color: " #c5c5c5",
                          fontSize: "11px",
                          top: "-8px",
                        }}
                      >
                        %
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("transformOriginX")}
              />
              <div
                className="tr"
                style={{
                  marginRight: "30px",
                  marginLeft: "20px",
                }}
              >
                Y
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginRight: "0" }}
                id="xCoord"
                value={popUpOptions.transformOriginY}
                name="transformOriginY"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    marginTop: "-6px",
                    height: "20px",
                    fontSize: "11px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          color: " #c5c5c5",
                          fontSize: "11px",
                          top: "-8px",
                        }}
                      >
                        %
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("transformOriginY")}
              />
              <div
                className="tr"
                style={{ marginRight: "30px", marginLeft: "20px" }}
              >
                Z
              </div>
              <TextField
                disabled={selectedComponent?.componentStyles?.lockBoolean}
                className="textFieldSP textFieldtransXY"
                style={{ marginRight: "0" }}
                id="xCoord"
                value={popUpOptions.transformOriginZ}
                name="transformOriginZ"
                size="small"
                autoComplete="off"
                InputProps={{
                  style: {
                    marginTop: "-6px",
                    height: "20px",
                    fontSize: "11px",
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <span
                        style={{
                          color: " #c5c5c5",
                          fontSize: "11px",
                          top: "-8px",
                        }}
                      >
                        px
                      </span>
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => handleChangeTimelineProps(e)}
                onBlur={(e) => handleChangeTimelineProps(e, "blur")}
                onKeyDown={handleKeyDown("transformOriginZ")}
              />
            </div>
          </div>
          <button
            className="applyButton"
            ref={buttonRef}
            onClick={() => {
              let x = "diamondIcon";
              if (!selectedComponent?.keyFrames?.length) {
                x = "powerIcon";
                setShowTooltip(true);
                setTimeout(() => {
                  setShowTooltip(false);
                }, 2000);
              }
              keyFrameClicked > -1 ? updateKeyFrames(x) : addKeyFrames(x);
              setOpenTimelinePopup({
                popupWindow: false,
                fromUnRedo: false,
              });
              setIsNewAnimationOpen(false);
            }}
          >
            {`${keyFrameClicked > -1 ? "UPDATE" : "APPLY"}`}
          </button>
        </div>
      </div>
      <div className="arrow-down"></div>
    </div>,
    document.body,
  );
}

export default CustomanimationPopup;
